var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sweet-modal",
    { ref: "deleteAnnouncementModal", attrs: { icon: "warning" } },
    [
      _vm.selected !== null
        ? _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("p", {
                staticClass: "mt-3",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t(
                      "pages.admin.livestream.announcements.delete.confirmation",
                      { title: _vm.selected.title[_vm.$i18n.locale] }
                    )
                  )
                }
              }),
              _vm._v(" "),
              _c(
                "delete-confirmation",
                { on: { clicked: _vm.deleteSelected } },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("actions.delete")) +
                      "\n        "
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }